import { computed } from "vue";
import { container } from "tsyringe";

// entities
import useAuthenticationStore from "@/entities/user/infrastructure/userStore";

// features
import { useQueryRegistrationRequests } from "@/features/pending-registration/services/query/useQueryRegistrationReuqests";
import { PendingRegistrationUserConverter } from "@/features/pending-registration/models/converter/PendingRegistrationUserConverter";

export const useGetPendingRegistrationUserList = () => {
    const authenticationStore = useAuthenticationStore();
    const pendingRegistrationUserConverter = container.resolve(PendingRegistrationUserConverter);

    const {
        registrationRequestsDto,
        isPending: isPendingRegistrationRequests,
        isFetchingNextPage,
        fetchNextPage,
        hasNextPage,
        isFetchNextPageError,
        error,
    } = useQueryRegistrationRequests({ academyId: authenticationStore.authState.academyId });

    const totalCount = computed(() => {
        if (!registrationRequestsDto.value) return 0;

        return registrationRequestsDto.value.pages[0].totalCount;
    });

    const convertedPendingRegistrationUserList = computed(() => {
        if (!registrationRequestsDto.value) return [];

        // useInfiniteQuery 이기에 전달받는 데이터는 페이지내이션이 될 수록 중첩된 배열로 전달됩니다.
        // 이에 flatMap 을 통해 해당 중첩 배열을 단일 배열로 변경한 뒤, 여기서 items 만 추출합니다.
        return pendingRegistrationUserConverter.convert(
            registrationRequestsDto.value.pages.flatMap((page) => page.items),
        );
    });

    return {
        convertedPendingRegistrationUserList,
        isPendingRegistrationRequests,
        isFetchingNextPage,
        fetchNextPage,
        hasNextPage,
        isFetchNextPageError,
        totalCount,
        error,
    };
};
